export default "__VITE_ASSET__D8Ov24D2__"